class KeyFeaturesMarquee extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.key-features-track');
    this.speed = parseInt(this.dataset.speed || 3);
    this.direction = this.dataset.direction || 'left';
    this.pauseOnHover = this.dataset.pauseOnHover === 'true';
    
    // Bind the methods to preserve the context
    this.boundPauseAnimation = this.pauseAnimation.bind(this);
    this.boundStartAnimation = this.startAnimation.bind(this);
  }

  connectedCallback() {
    // Calculate animation duration based on content width and speed
    this.calculateAnimationDuration();
    
    // Set initial attributes
    this.setAttribute('data-direction', this.direction);
    
    // Start animation
    this.startAnimation();

    // Add event listeners if pause on hover is enabled
    if (this.pauseOnHover) {
      this.addEventListener('mouseenter', this.boundPauseAnimation);
      this.addEventListener('mouseleave', this.boundStartAnimation);
    }

    // Handle visibility changes
    this.setupVisibilityHandler();
    
    // Handle resize events
    window.addEventListener('resize', this.debounce(() => {
      this.calculateAnimationDuration();
    }, 250));
  }

  calculateAnimationDuration() {
    const trackWidth = this.track.scrollWidth / 2; // Divide by 2 because content is duplicated
    const baseSpeed = 10; // Base pixels per second
    const duration = (trackWidth / (baseSpeed * this.speed));
    this.style.setProperty('--scroll-speed', `${duration}s`);
  }

  startAnimation() {
    this.setAttribute('data-animating', '');
  }

  pauseAnimation() {
    this.removeAttribute('data-animating');
  }

  setupVisibilityHandler() {
    // Pause animation when not visible to improve performance
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.startAnimation();
        } else {
          this.pauseAnimation();
        }
      });
    }, { threshold: 0 });

    observer.observe(this);
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  disconnectedCallback() {
    if (this.pauseOnHover) {
      this.removeEventListener('mouseenter', this.boundPauseAnimation);
      this.removeEventListener('mouseleave', this.boundStartAnimation);
    }
  }
}

customElements.define('key-features-marquee', KeyFeaturesMarquee); 